import adminRoutes from './adminRoutes';
import managerRoutes from './managerRoutes';
import candidateRoutes from './candidateRoutes';
import recruiterRoutes from './recruiterRoutes';
import employerRoutes from './employerRoutes';
import userRoutes from './userRoutes';
import managerUserRoutes from './managerUserRoutes';

import publicRoutes from './publicRoutes';
import employerJobPortal from './employerJobPortal';
import notFoundRoutes from './notFoundRoutes';
import prototypeRoutes from './prototypeRoutes';

export default [
  ...notFoundRoutes,
  ...employerJobPortal,
  ...publicRoutes,
  ...candidateRoutes,
  ...adminRoutes,
  ...recruiterRoutes,
  ...managerRoutes,
  ...userRoutes,
  ...prototypeRoutes,
  ...employerRoutes,
  ...managerUserRoutes,
];
